const STORAGE_KEY = 'mangitalia_partner_analytics';

function readQueue() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function writeQueue(events) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(events.slice(-100)));
  } catch {
    /* ignore quota errors */
  }
}

function pushToExternalAnalytics(event, payload, path) {
  if (typeof window === 'undefined') return;

  // Google Analytics 4 (gtag)
  if (typeof window.gtag === 'function') {
    window.gtag('event', event, {
      ...payload,
      page_path: path,
      send_to: import.meta.env.VITE_GA4_MEASUREMENT_ID || undefined,
    });
  }

  // dataLayer (GTM)
  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event,
      ...payload,
      page_path: path,
    });
  }

  // Plausible
  if (typeof window.plausible === 'function') {
    window.plausible(event, { props: { ...payload, path } });
  }
}

/**
 * Traccia eventi di conversione (locale + GA4/Plausible/GTM se presenti).
 * Imposta VITE_GA4_MEASUREMENT_ID e/o carica lo script in index.html.
 */
export function trackPartnerEvent(event, payload = {}) {
  const entry = {
    event,
    payload,
    ts: new Date().toISOString(),
    path: typeof window !== 'undefined' ? window.location.pathname : '',
  };

  if (import.meta.env.DEV) {
    console.info('[partner-analytics]', entry);
  }

  const queue = readQueue();
  queue.push(entry);
  writeQueue(queue);

  pushToExternalAnalytics(event, payload, entry.path);

  window.dispatchEvent(new CustomEvent('mangitalia:partner-analytics', { detail: entry }));
}

export function getPartnerAnalyticsQueue() {
  return readQueue();
}
